module.exports = __webpack_public_path__ + "assets/images/pages/ministerioconsumo/grid-2.png?a8e19d8b";